exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label span.warning[data-v-000162a4]{color:#c31616}#barcode-scan[data-v-000162a4]{text-align:center;align-items:center;margin-bottom:15px;font-size:1.4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-000162a4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bouteille/NewBouteille.vue
// module id = 613
// module chunks = 0